<template>
  <b-row
    id="footer"
    :class="[isSidebarOpened ? 'side-bar-opened' : '']"
    align-h="between"
    align-v="center"
    no-gutters
  >
    <b-row
      class="mr-auto"
      no-gutters>
      <b-dropdown
        ref="languagePopup"
        class="custom-dropdown"
        variant="transparent"
        dropup
        @toggle="onToggleLanguageDropdown"
      >
        <template slot="button-content">
          <span class="current-language">
            {{ currentLanguage.langNm }}
          </span>
        </template>
        <b-dropdown-form
          v-for="(language) in languageOptions"
          :key="language.langCd"
        >
          <b-row
            no-gutters
            @click="onSelectLanguage(language)"
          >
            {{ language.langNm }}
          </b-row>
        </b-dropdown-form>
      </b-dropdown>
    </b-row>
    <b-row
      no-gutters
      class="utils"
    >
      <div class="policy">
        <!-- 서비스 약관-->
        <a
          target="_blank"
          class="vertical-stick"
          @click="moveAgreement()"
        >
          {{ $t('footer.agreement') }}
        </a>
        <!-- 개인정보 처리방침 -->
        <a
          target="_blank"
          class="vertical-stick font-family-notosanscjkkr-Bold"
          @click="movePrivacy()"
        >
          {{ $t('footer.privacyPolicy') }}
        </a>
        <!--제 3자 솔루션 이용동의-->
        <a
          v-if="domain === 'opsnow.com'"
          target="_blank"
          class="vertical-stick"
          @click="moveThirdPartyServiceTerms()"
        >
          {{ $t('footer.thirdPartyServiceTerms') }}
        </a>
        <!--기술지원 및 문의-->
        <a
          v-if="showzeService"
          target="_blank"
          @click="moveSupport"
        >
          {{ $t('footer.technicalSupport') }}
        </a>
        <BasePopup
          ref="techSupport"
          :title="$t('footer.technicalSupport')"
          :content="techSupportContent"
          :button-text="$t('common.button.ok')"
          popup-ref="techSupport"
        />
      </div>
      <p
        id="footer_copyright"
        class="company-info">
        Copyright © 2019 OpsNow All Rights Reserved
      </p>
    </b-row>
    <div
      id="opsbot"
      :lang="getLocale"
      :site="getSite"
      bottom="120px"
      right="50px"
      data-dns="chatbot.opsnow.com"
      data-id="8cfa42cd-2409-4551-9280-0bc722f2ae6b"
    />
  </b-row>
</template>
<script>
  import {mapGetters} from "vuex";
  import ENDPOINT from "@/api/endpoints";
  import {LANGUAGE_OPTIONS} from '@/constants/trans'
  import {setValueToStorageByKey, LOCAL_STORAGE_KEY} from '@/util/localStorage';
  import Profile from '@/components/common/profile';
  import {CLASSIC_VERSION_PAGE, CLASSIC_VERSION_URL} from '@/constants/constants'
  import {SUPPORTED_LANGUAGE} from "../../../constants/trans";
  import axios from "axios";
  import _ from "lodash";
  import BasePopup from '../BasePopup'

  const env = Profile.env === 'PROD' || Profile.env === 'CHINA' || Profile.env === 'LGE'? 'PRODUCTION' : 'DEV';
  const CLASSIC_VERSION_URL_BY_PAGE = CLASSIC_VERSION_URL[env]

  export default {
    name: 'BaseFooter',
    components: {
      BasePopup,
    },
    props: {
      isSidebarOpened: {
        type: Boolean,
        default: false
      },
    },
    data () {
      return {
        footer: {},
        languageOptions: [],
        currentLanguage: null,
        CLASSIC_VERSION_URL_BY_PAGE : CLASSIC_VERSION_URL_BY_PAGE,
        CLASSIC_VERSION_PAGE: CLASSIC_VERSION_PAGE,
        domain: location.hostname.split('.').slice(1).join('.'),
      }
    },
    computed: {
      ...mapGetters({
        language: 'common/language',
      }) ,
      getLocale: function() {
        return this.$i18n.locale;
      },
      getSite: function() {
        return location.hostname;
      },
      showzeService: function () {
        return !_.isEmpty(this.$store.state.loginUser);
      },
      techSupportContent() {
        return `
        <p class="layout-popup-message support" style="text-align: left;">
          TEL<br>
          ${this.footer.techTelCntrCd} ${this.footer.techTelNo}<br>
          <br>
          E MAIL<br>
          ${this.footer.techEmail}<br>
        </p>
        `
      },
    },
    watch: {
      language: {
        handler() {
          this.currentLanguage = this.languageOptions.find(lang => lang.langCd === this.getLocale)
          //디폴트 언어 설정
          if(this.currentLanguage == undefined) {
            this.currentLanguage = {langCd: SUPPORTED_LANGUAGE.EN, langNm: 'English'}
          }
        },
        immediate: true
      },
      getLocale () {
        this.showOpsBot();
      }
    },
    mounted() {
      this.showOpsBot();
    },
    created: function(){
      this.getHomepageInfo();
    },
    methods:{
      onToggleLanguageDropdown() {
        this.$store.dispatch('costAnalytics/setIsCloseQuickFilterDropdown', true);
      },
      onSelectLanguage(lang) {
        if (this.currentLanguage.langCd !== lang.langCd) {
          this.$i18n.locale = lang.langCd
          setValueToStorageByKey(LOCAL_STORAGE_KEY.LANGUAGE, lang.langCd)
          this.$cookies.set(this.constants.LangCode, lang.langCd, "1y" , '/', typeof(this.$store.state.sub_domain) !== this.constants.UNDEFINED ? this.$store.state.sub_domain : '')
          this.$store.dispatch('common/setLang', lang.langCd);
        }
        this.$refs.languagePopup.hide()
        // window.location.href =  window.location.protocol + "//" + window.location.host +'/'
      },
      // MSP 홈페이지 정보 조회
      getHomepageInfo() {
        let host = window.location.host
        let url = ENDPOINT.GNB_EARTH.HOMEPAGE_INFO + '?host='+ host + '&langcd=' + this.getLocale
        axios.get(url)
          .then(response => {
            if(response.data.status == 'ok') {
              this.footer = response.data.result.footer;
              this.languageOptions = response.data.result.availableLang;
              $('#footer_copyright').html(response.data.result.footer.copyRight);

              let logo = response.data.result.logo;

              if(logo.mspCmpnLogoTypeCd == 'MSP_CMPN_LOGO_TYPE_010') {
                $('#footer_title').html(`<img src="${logo.logoFooter}">`)
              } else {
                $('#footer_title').html(logo.logoFooterText);
              }
            }
          });
      },
      moveOtherService(actionUrl){
        let url = this.urls.portalUrl;
        url = url  + actionUrl;
        location.href = url;
      },
      // FreshService로 이동
      moveSupport: function () {
        const domain = location.hostname.split('.').slice(1).join('.')
        if (domain === 'opsnow.com' || domain === 'opsnow360.com' || domain === '.sec-alertnow.com') {
          window.open(this.urls.supportUrl);
        } else {
          this.$refs.techSupport.show();
        }
      },
      moveAgreement() {
        const langCd = this.getLocale === 'ko' ? 'kr' : 'en'
        location.href = this.domain === 'opsnow.com'
          ? `https://www.opsnow.com/legal/${langCd}/terms-of-service`
          : this.urls.portalUrl + '/agreement/service';
      },
      moveThirdPartyServiceTerms() {
        const langCd = this.getLocale === 'ko' ? 'ko' : 'en'
        location.href = `https://www.opsnow.com/${langCd}/legal/third-party-service-terms`
      },
      movePrivacy() {
        const langCd = this.getLocale === 'ko' ? 'kr' : 'en'
        location.href = this.domain === 'opsnow.com'
          ? `https://www.opsnow.com/legal/${langCd}/privacy-policy`
          : this.urls.portalUrl + '/agreement/privacy';
      },
      showOpsBot() { // 상담서비스 호출
        const domain = location.hostname.split('.').slice(1).join('.')
        if (domain === 'opsnow.cn') { // 차이나 제외
          return;
        }

        if (domain.indexOf('.sktelecomcloud') > -1) { // sk ct 센터 도메인 제외 (***.opsnow.sktelecomcloud.com)
          return;
        }

        if (domain !== 'opsnow.com' && domain !== 'opsnow360.com') {	// WL 제외
          return;
        }

        if (document.getElementById('opsbot-js')) {
          const el = document.getElementById('opsbot-js')
          el.remove();
        }
        var js, omj = document.getElementsByTagName('script')[0];
        js = document.createElement('script');
        js.id = 'opsbot-js';
        js.src = 'https://bb8-server-prod.prd.helpnow.ai/api/scripts/opsbot.min.js';
        omj.parentNode.insertBefore(js, omj);
      },
    },
  };
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/common/base-footer/BaseFooter.vue